import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Hero from '../components/Hero'
import About from '../components/About'
import Ecosystem from '../components/Ecosystem'
import ContentHub from '../components/ContentHub'
import Volunteering from '../components/Volunteering'

export default function Home() {
  const location = useLocation()

  useEffect(() => {
    // Handle hash navigation on page load
    if (location.hash) {
      const targetId = location.hash.replace('#', '')
      setTimeout(() => {
        const element = document.getElementById(targetId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
    }
  }, [location])

  return (
    <main>
      <Hero />
      <About />
      <Ecosystem />
      <ContentHub />
      <Volunteering />
    </main>
  )
}
